import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC026_Request,
  IAPI_FAC026_Response,
  IAPI_FAC012_Request,
  IAPI_FAC012_Response,
} from "../../../type/apiType";
// 施設転換後非加入参照
// API仕様書_施設
const httpIAPI_FAC026 = async (
  param: IAPI_FAC026_Request
): Promise<IAPI_FAC026_Response> => {
  let res = await http.post(ApiUrl.API_FAC026, {
    ...param,
  });
  return res.data;
};

// 施設を転換後加入させない旨の届更新API
// API仕様書_施設
const httpIAPI_FAC012 = async (
  param: IAPI_FAC012_Request
): Promise<IAPI_FAC012_Response> => {
  let res = await http.post(ApiUrl.API_FAC012, {
    ...param,
  });
  return res.data;
};

export { httpIAPI_FAC026, httpIAPI_FAC012 };
